<template>
  <div class="control">
    <b-taglist attached>
      <b-tag type="is-primary is-medium">{{ filename }}</b-tag>
      <b-tag type="is-dark is-medium">
        <span @click="$emit('DOWNLOAD_FILE')">
          <b-icon
            class="pointer-cursor"
            icon="download"
            style="color: lightgreen"
          />
        </span>
        <span v-if="fileOwner === true" @click="$emit('DELETE_FILE')">
          <b-icon
            class="pointer-cursor"
            icon="delete"
            style="margin-left: 0.5rem; color: lightgray"
        /></span>
      </b-tag>
    </b-taglist>
  </div>
</template>
<script>
export default {
  name: 'FileTag',
  props: ['filename', 'filetype', 'fileOwner']
}
</script>

<style lang="scss" scoped>
.pointer-cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/infrastructure/fileuploads/components/FileTag.vue